function extractScriptContent(originalHtml: string) {
  const startTag = '<script';
  const endTag = '</script>';

  const lastStartIndex = originalHtml.lastIndexOf(startTag);
  const lastEndIndex = originalHtml.indexOf(endTag, lastStartIndex);

  if (lastStartIndex === -1 || lastEndIndex === -1) {
    // No script tag found
    return null;
  }

  const contentStart = originalHtml.indexOf('>', lastStartIndex) + 1;
  const contentEnd = lastEndIndex;

  return originalHtml.slice(contentStart, contentEnd).trim();
}

export function extractQuestionAnswer(originalHtml: string) {
  let questionHtml = ``;
  let answerHtml = ``;
  let scriptContent: string | null = ``;

  const startIndex = originalHtml.indexOf('<div class="answer_container');
  const endIndex =
    originalHtml.lastIndexOf('</div>', originalHtml.length) + '</div>'.length;

  if (startIndex !== -1 && endIndex !== -1) {
    answerHtml = originalHtml
      .slice(startIndex, endIndex)
      .replace('answer:', '')
      .replace('Answer:', '');

    questionHtml =
      originalHtml.slice(0, startIndex) + originalHtml.slice(endIndex);
  } else {
    console.log('Element not found');
    return { questionHtml: originalHtml, answerHtml: '' };
  }

  scriptContent = extractScriptContent(originalHtml);

  return { questionHtml, answerHtml, scriptContent };
}
